export default __webpack_public_path__ + "static/media/apecoin.52dea6a2.pdf";